import { useContext, useEffect, useState } from "react";
import type { Translate } from "next-translate";
import { getT } from "@/utils/helpers";
import { DynamicLocalizationContext } from "@/context";

interface DynamicTranslationOptions {
  loading: (key: string) => string;
}

interface DynamicTranslationResult {
  t: Translate;
  ready: boolean;
  lang?: string;
}

export function useDynamicTranslation(
  ns: string | string[] = ["common", "shared", "validations"],
  { loading }: DynamicTranslationOptions = { loading: () => "" }
): DynamicTranslationResult {
  const { lang = "tr" } = useContext(DynamicLocalizationContext)!;
  const [translator, setTranslator] = useState<Translate>();
  const [isLoading, setIsLoading] = useState(true);

  const getTranslation = async () => {
    setIsLoading(true);
    const t = (await getT(ns)) as Translate;
    setTranslator(() => t);
    setIsLoading(false);
  };

  useEffect(() => {
    getTranslation();
  }, [lang]);

  if (isLoading) {
    return {
      t: ((key: string | TemplateStringsArray) => loading(String(key))) as Translate,
      ready: false,
    };
  }

  return {
    t: translator as Translate,
    ready: true,
    lang,
  };
}
